export const jsonPostSlider = (e) => {
  let json = [];
  let i = 0;
  //console.log(e.target.parentElement.parentElement.children)
  let target = e.target.parentElement.parentElement.children;
  const tempTarget = [...target]
  const showedQuestion = tempTarget.filter(e => e.className.includes('show'))

  showedQuestion.forEach(q => {
    const labels = q.children[1].children
    const tempLabels = [...labels]

    tempLabels.forEach(lab => {
      //Verifica si las respuestas tienen implementada la organización por calidad, porque si lo tienen el DOM se organiza de otra manera y la obtención de las respuestas es diferente
      if (lab.className == 'bad' || lab.className == 'semibad' || lab.className == 'regular' || lab.className == 'semigood' || lab.className == 'good') {
        
        const tempQualDiv = [...lab.children]
        tempQualDiv.forEach(qualDiv => {

          const myInput = qualDiv.children[0].firstChild
          let IdPregunta = myInput.name;
          if (myInput.name !== "g-recaptcha-response") {
            if (myInput.checked) {
              if (json[i] === undefined) {
                if (isNaN(myInput.value)) {
                  json.push({ IdPregunta: IdPregunta, IdRespuesta: myInput.id, subPreguntaId: myInput.getAttribute('subpreguntaid') })
                } else {
                  json.push({ IdPregunta: IdPregunta, IdRespuesta: myInput.value, subPreguntaId: myInput.getAttribute('subpreguntaid') })
                }
              }
            }
            
            if (target[i].type === 'text' && target[i].value != '') { json.push({ IdPregunta: target[i].name, TextoRespuesta: target[i].value, type: "text", subPreguntaId: target[i].getAttribute('subpreguntaid') }) };

            if (myInput.id == 'select' && myInput.selectedOptions[0].innerText != 'Elige una opción') {
              json.push({ IdPregunta: IdPregunta, TextoRespuesta: target[5].selectedOptions[0].innerText, type: 'select', subPreguntaId: myInput.selectedOptions[0].getAttribute('subpreguntaid') })
            };

            if (!myInput.checked && Number(IdPregunta) < Number(myInput.name)) {
              if (myInput.checked) json.push({ IdPregunta: myInput.name, IdRespuesta: myInput.name })
            }
            
            if (myInput.type === 'textarea' && myInput.value != '') { json.push({ IdPregunta: myInput.name, TextoRespuesta: myInput.value, type: "text", subPreguntaId: myInput.getAttribute('subpreguntaid') }) };
            IdPregunta = myInput.name;
          }
        })
      } else {
        let IdPregunta
        if (lab.tagName === 'LABEL') {
          //console.log(lab)
          IdPregunta = lab.firstChild.name;
          if (lab.firstChild.name !== "g-recaptcha-response") {
            if (lab.firstChild.checked) {
              if (true) {
                if (isNaN(lab.firstChild.value)) {
                  json.push({ IdPregunta: IdPregunta, IdRespuesta: lab.firstChild.id, subPreguntaId: lab.firstChild.getAttribute('subpreguntaid') })
                } else {
                  json.push({ IdPregunta: IdPregunta, IdRespuesta: lab.firstChild.value, subPreguntaId: lab.firstChild.getAttribute('subpreguntaid') })
                }
              }
            }
            
            if (target[i].type === 'text' && target[i].value != '') { json.push({ IdPregunta: target[i].name, TextoRespuesta: target[i].value, type: "text", subPreguntaId: target[i].getAttribute('subpreguntaid') }) };

            if (lab.firstChild.id == 'select' && lab.firstChild.selectedOptions[0].innerText != 'Elige una opción') {
              json.push({ IdPregunta: IdPregunta, TextoRespuesta: target[5].selectedOptions[0].innerText, type: 'select', subPreguntaId: lab.firstChild.selectedOptions[0].getAttribute('subpreguntaid') })
            };

            if (!lab.firstChild.checked && Number(IdPregunta) < Number(lab.firstChild.name)) {
              if (lab.firstChild.checked) json.push({ IdPregunta: lab.firstChild.name, IdRespuesta: lab.firstChild.name })
            }
            
            if (lab.firstChild.type === 'textarea' && lab.firstChild.value != '') { json.push({ IdPregunta: lab.firstChild.name, TextoRespuesta: lab.firstChild.value, type: "text", subPreguntaId: lab.firstChild.getAttribute('subpreguntaid') }) };
            IdPregunta = lab.firstChild.name;
          }
        } else {
          IdPregunta = lab.name;
          if (lab.name !== "g-recaptcha-response") {
            if (lab.checked) {
              if (true) {
                if (isNaN(lab.value)) {
                  json.push({ IdPregunta: IdPregunta, IdRespuesta: lab.id, subPreguntaId: lab.getAttribute('subpreguntaid') })
                } else {
                  json.push({ IdPregunta: IdPregunta, IdRespuesta: lab.value, subPreguntaId: lab.getAttribute('subpreguntaid') })
                }
              }
            }
            
            if (lab.type === 'text' && lab.value != '') { json.push({ IdPregunta: lab.name, TextoRespuesta: lab.value, type: "text", subPreguntaId: lab.getAttribute('subpreguntaid') }) };

            if (lab.id == 'select' && lab.selectedOptions[0].innerText != 'Elige una opción') {
              json.push({ IdPregunta: IdPregunta, TextoRespuesta: lab.selectedOptions[0].innerText, type: 'select', subPreguntaId: lab.selectedOptions[0].getAttribute('subpreguntaid') })
            };

            if (!lab.checked && Number(IdPregunta) < Number(lab.name)) {
              if (lab.checked) json.push({ IdPregunta: lab.name, IdRespuesta: lab.name })
            }

            if (lab.type === 'textarea' && lab.value != '') { json.push({ IdPregunta: lab.name, TextoRespuesta: lab.value, type: "text", subPreguntaId: lab.getAttribute('subpreguntaid') }) };
            IdPregunta = lab.name;
            
            if (lab.children[0]?.type === 'textarea' && lab.children[0]?.value != '') { json.push({ IdPregunta: lab.children[0].name, TextoRespuesta: lab.children[0].value, type: "text", subPreguntaId: lab.children[0].getAttribute('subpreguntaid') }) };
            IdPregunta = lab.children[0]?.name;
          }
        }

      }

    })
  })










  while (i < target.length) {
    let IdPregunta = target[i].name;
    if (target[i].name !== "g-recaptcha-response") {
      if (target[i].checked) {
        if (json[i] === undefined) {
          if (isNaN(target[i].value)) {
            json.push({ IdPregunta: IdPregunta, IdRespuesta: target[i].id, subPreguntaId: target[i].getAttribute('subpreguntaid') })
          } else {
            json.push({ IdPregunta: IdPregunta, IdRespuesta: target[i].value, subPreguntaId: target[i].getAttribute('subpreguntaid') })
          }
        }
      }
      
      if (target[i].type === 'text' && target[i].value != '') { json.push({ IdPregunta: target[i].name, TextoRespuesta: target[i].value, type: "text", subPreguntaId: target[i].getAttribute('subpreguntaid') }) };

      if (target[i].id == 'select' && target[i].selectedOptions[0].innerText != 'Elige una opción') {
        json.push({ IdPregunta: IdPregunta, TextoRespuesta: target[5].selectedOptions[0].innerText, type: 'select', subPreguntaId: target[i].selectedOptions[0].getAttribute('subpreguntaid') })
      };

      if (!target[i].checked && Number(IdPregunta) < Number(target[i].name)) {
        if (target[i].checked) json.push({ IdPregunta: target[i].name, IdRespuesta: target[i].name })
      }
      
      if (target[i].type === 'textarea' && target[i].value != '') { json.push({ IdPregunta: target[i].name, TextoRespuesta: target[i].value, type: "text", subPreguntaId: target[i].getAttribute('subpreguntaid') }) };
      IdPregunta = target[i].name;
    }
    i++;

  }
  return json;
}
